/**
 * kill-client-request.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class KillClientRequest extends ReplyVerifyingMessage
{
    public tag : MessageTag = MessageTag.REQ_KILL_CLIENT;
	public static tag : MessageTag = MessageTag.REQ_KILL_CLIENT;

    constructor (public channelId : string)
    {
        super();
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/kill-client-request.ts